import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CustomKeycloakService } from '../keycloak.service';
import { UserService } from '../user.service';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = async() => {
  if (environment.isTesting) return true;
  const userService = inject(UserService);
  const keycloakService = inject(CustomKeycloakService);
  const router = inject(Router);

  console.log('AuthGuard: Checking authentication...');

  try {
    const isTokenValid = keycloakService.isStoredTokenValid();

    if (isTokenValid) {
      return true;
    }

    const storedToken = keycloakService.getStoredAccessToken();
    if (storedToken) {
      const refreshSuccess = await keycloakService.refreshStoredToken();
      if (refreshSuccess) {
        return true;
      }
    }

    if (keycloakService.isSSOAuthenticated()) {
      return true;
    }

    if (
      !keycloakService.isStoredTokenValid() &&
      !keycloakService.getStoredAccessToken()
    ) {
      await keycloakService.loginWithSSO();
      return false;
    }
  } catch (error) {
    console.warn('Error checking Keycloak authentication:', error);
  }

  const legacyToken =
    userService.currentAccessToken || localStorage.getItem('access_token');

  if (legacyToken) {
    return true;
  }

  return router.createUrlTree(['/login']);
};
